import React from 'react';
import { Button, Icon, SemanticICONS, SemanticCOLORS } from 'semantic-ui-react';
import { withTranslation, useTranslation } from 'react-i18next';

type SemanticCOLORS = typeof SemanticCOLORS;
type SemanticICONS = typeof SemanticICONS;

type Props = {
  label?: string;
  type?: 'button' | 'submit' | 'reset';
  primary?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  color?: SemanticCOLORS;
  className?: string;
  loading?: boolean;
  icon?: SemanticICONS;
  id?: string;
  labelPosition?: 'left' | 'right';
  size?: 'mini' | 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge' | 'massive';
};
const ButtonWrapper = ({
  label,
  type = 'button',
  primary = false,
  onClick,
  disabled,
  color,
  className = 'mini',
  loading = false,
  icon,
  id,
  labelPosition,
  size,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Button
      id={id}
      type={type}
      primary={primary}
      onClick={onClick}
      color={color}
      disabled={disabled}
      className={className}
      icon={icon}
      loading={loading}
      size={size}
      labelPosition={label && icon ? labelPosition || 'left' : undefined}
    >
      {label ? (
        <>
          {icon && <Icon name={icon} />}
          {t(label)}
        </>
      ) : null}
    </Button>
  );
};
export default withTranslation()(ButtonWrapper);
